import * as React from "react";
const SvgMinus = (props) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.333 8h9.334", stroke: "#101828", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgMinus;
